import React, { useEffect } from 'react';

import BaseFilter from './BaseFilter';

type ToggleFilterProps = {
    name: string;
    label: string;
    disabled?: boolean;
    onApply: () => void;
    onDelete: () => void;
}

/*
    A filter that only has one option, on or off. Does not have children and will not open any collapsable.

    When mounted(selected from the filter list), it will call onApply immediately.

    When the selected filter is clicked, it will be call onDelete.
 */
const ToggleFilter = ({ name, onApply, onDelete, disabled, label }: ToggleFilterProps) => {

    useEffect(() => {
        onApply();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <BaseFilter
            initialOpen={false}
            label={label}
            disabled={disabled}
            applyIsDisabled={false}
            name={name}
            onApply={onApply}
            onDelete={onDelete}
            useAsToggleButton={true}
        />
    );
};

export default ToggleFilter;
